import { useMutation } from '@tanstack/react-query';

import * as memberMaintainServices from 'services/memberMaintenance';

export const useGetAllMemberForHierarchies = () =>
  useMutation({
    mutationFn: memberMaintainServices.getAllMemberForHierarchies,
  });

export const useActionMemberHirarchies = () =>
  useMutation({
    mutationFn: memberMaintainServices.actionMemberHirarchies,
  });
